import {
  Channel,
  ChannelFilters,
  ChannelPhase,
  Idea,
} from '@frontend/data-access';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type KanbanLoadingStates = {
  [phaseId: string]: boolean;
};
export interface IdeaChannelState {
  channel: Channel | null;
  filters: ChannelFilters | null;
  ideaSortby: 'ASC' | 'DESC';
  allIdeas: Idea[];
  loadingStates: KanbanLoadingStates;
}

export const initialState: IdeaChannelState = {
  channel: null,
  filters: null,
  ideaSortby: 'ASC',
  allIdeas: [],
  loadingStates: {},
};

const ideaChannelSlice = createSlice({
  name: 'ideaChannel',
  initialState,
  reducers: {
    setChannel: (state, action: PayloadAction<Channel>) => {
      state.channel = action.payload;
    },
    setChannelFilters: (
      state,
      action: PayloadAction<ChannelFilters | null>
    ) => {
      state.filters = action.payload;
    },
    setIdeaSortby: (state, action: PayloadAction<'ASC' | 'DESC'>) => {
      state.ideaSortby = action.payload;
    },
    setAllIdeas: (state, action: PayloadAction<Idea[]>) => {
      state.allIdeas = action.payload;
    },
    setChannelPhaseIdeaById: (state, action: PayloadAction<ChannelPhase>) => {
      state.channel = {
        ...state.channel,
        channelPhases:
          state.channel?.channelPhases.map((phase) =>
            phase.phase.id === action.payload.phase.id ? action.payload : phase
          ) || [],
      } as Channel;
    },
    setLoadingStates: (state, action: PayloadAction<KanbanLoadingStates>) => {
      state.loadingStates = {
        ...state.loadingStates,
        ...action.payload,
      };
    },
  },
});

export const {
  setChannel,
  setChannelFilters,
  setIdeaSortby,
  setAllIdeas,
  setChannelPhaseIdeaById,
  setLoadingStates,
} = ideaChannelSlice.actions;

export default ideaChannelSlice.reducer;
